import { render, staticRenderFns } from "./Mailbox.vue?vue&type=template&id=638b91bc&"
import script from "./Mailbox.vue?vue&type=script&lang=js&"
export * from "./Mailbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Mailbox.vue
// module id = null
// module chunks = 